"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ProductsCodeListsProvider = _interopRequireDefault(require("../ProductsCodeListsProvider"));

var _ProductsContext = _interopRequireDefault(require("./ProductsContext"));

function ProductsProvider(_ref) {
  var cacheHook = _ref.cacheHook,
      children = _ref.children,
      clientCode = _ref.clientCode,
      codeListOptions = _ref.codeListOptions,
      serviceNames = _ref.serviceNames,
      uiRouteBase = _ref.uiRouteBase;
  return _react.default.createElement(_ProductsContext.default.Provider, {
    value: {
      cacheHook: cacheHook,
      clientCode: clientCode,
      serviceNames: serviceNames,
      uiRouteBase: uiRouteBase
    }
  }, _react.default.createElement(_ProductsCodeListsProvider.default, {
    cacheHook: cacheHook,
    clientCode: clientCode,
    codeListOptions: codeListOptions
  }, children));
}

ProductsProvider.propTypes = {
  cacheHook: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array]),
  children: _propTypes.default.node,
  clientCode: _propTypes.default.string,
  codeListOptions: _propTypes.default.shape({
    disableOnAuth: _propTypes.default.bool
  }),
  serviceNames: _propTypes.default.shape({
    productParameterGroupTypes: _propTypes.default.shape({
      list: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      serviceName: _propTypes.default.string,
      update: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      version: _propTypes.default.string
    }),
    productParameterTypes: _propTypes.default.shape({
      list: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      serviceName: _propTypes.default.string,
      update: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      version: _propTypes.default.string
    }),
    products: _propTypes.default.shape({
      get: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      list: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      remove: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      serviceName: _propTypes.default.string,
      update: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      version: _propTypes.default.string
    })
  }),
  uiRouteBase: _propTypes.default.string
};
ProductsProvider.defaultProps = {
  cacheHook: undefined,
  children: null,
  clientCode: 'api',
  codeListOptions: undefined,
  serviceNames: undefined,
  uiRouteBase: '/products'
};
var _default = ProductsProvider;
exports.default = _default;